import React from "react";
import styled from "styled-components";

// Styled Components with theme-based colors
const FooterWrapper = styled.footer`
  padding: 20px;
  text-align: center;
  font-size: 0.9rem;
  border-top: 1px solid #ddd;
  background-color: ${(colors) => colors.colors.footerBackground};
  color: ${(colors) => colors.colors.footerText};
`;

const FooterText = styled.p``;

const Footer = ({ colors }) => {
  return (
    <FooterWrapper colors={colors}>
      <FooterText>© 2026-2027 ISAFE All rights reserved</FooterText>
      <FooterText>
        Duplication and/or selling of the information contained within this
        website, or any other form of unauthorized use of this copyrighted
        material, is against the law and a punishable crime.
      </FooterText>
    </FooterWrapper>
  );
};

export default Footer;
